// import React from 'react';
// import { TextField, Button, Grid, Typography } from '@mui/material';

// const OfferteTotals = ({ rows, formValues }) => {
//   // Calculate totals based on the rows data
//   const verkoopBedrag = rows.reduce((acc, row) => acc + parseFloat(row.total), 0).toFixed(2);
//   const kostPrijsBedrag = (0).toFixed(2); // You may update this logic based on your pricing strategy
//   const salesMarge = (verkoopBedrag - kostPrijsBedrag).toFixed(2);
//   const salesMargePercent = ((salesMarge / verkoopBedrag) * 100).toFixed(2);
//   console.log(formValues);
//   console.log(rows);

//   // const handleSave = async () => {
//   //   if (validate()) {
//   //     setIsSubmitting(true);
//   //     console.log('before save');
//   //     const body = {
//   //       formValues,
//   //       rows,
//   //        debtorId,
//       //     };
//   //     const path = `/details`;
//   //     const arg = { token, body };
//   //     const forecastres = await afasPoster(path, { arg });
//   //     console.log(forecastres);
//   //     subjectRefetch({ throwOnError: true, cancelRefetch: true });

//   //     // Hide success message after 3 seconds
//   //     setTimeout(() => {
//   //       setIsSubmitted(false);
//   //     }, 3000);
//   //   }
//   // };

//   return (
//     <div style={{ padding: '16px', marginTop: '24px' }}>
//       <Typography variant="h5" style={{ color: '#3f51b5', marginBottom: '16px' }}>
//         Totalen
//       </Typography>
//       <Grid container spacing={2}>
//         <Grid item xs={12} md={6}>
//           <TextField
//             label="Verkoopbedrag"
//             variant="filled"
//             size="small"
//             value={verkoopBedrag}
//             InputProps={{
//               readOnly: true,
//             }}
//             fullWidth
//             margin="normal"
//           />
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <TextField
//             label="Kostprijsbedrag"
//             variant="filled"
//             size="small"
//             value={kostPrijsBedrag}
//             InputProps={{
//               readOnly: true,
//             }}
//             fullWidth
//             margin="normal"
//           />
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <TextField
//             label="Sales marge"
//             variant="filled"
//             size="small"
//             value={salesMarge}
//             InputProps={{
//               readOnly: true,
//             }}
//             fullWidth
//             margin="normal"
//           />
//         </Grid>
//         <Grid item xs={12} md={6}>
//           <TextField
//             label="Sales marge %"
//             variant="filled"
//             size="small"
//             value={salesMargePercent}
//             InputProps={{
//               readOnly: true,
//             }}
//             fullWidth
//             margin="normal"
//           />
//         </Grid>
//       </Grid>
//       <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: '16px' }}>
//         <Grid item>
//           <Button variant="contained" color="secondary" size="large">
//             Annuleren
//           </Button>
//         </Grid>
//         <Grid item>
//           <Button variant="contained" color="primary" size="large">
//             Opslaan en sluiten
//           </Button>
//         </Grid>
//       </Grid>
//     </div>
//   );
// };

// export default OfferteTotals;

import React, { useState, useContext } from 'react';
import { TextField, Button, Grid, Typography, CircularProgress } from '@mui/material';
import { TokenContext } from '../context/TokenContext';
import { InSiteContext } from '../context/InSiteContext';
import { afasPoster } from '../hooks/useAfasDataMutation';

const OfferteTotals = ({ rows, formValues, debtorId, forecastId }) => {
  const [isSaving, setIsSaving] = useState(false);
  const token = useContext(TokenContext);
  const insiteUrl = useContext(InSiteContext);

  const verkoopBedrag = rows.reduce((acc, row) => acc + parseFloat(row.total), 0).toFixed(2);
  const kostPrijsBedrag = (0).toFixed(2);
  const salesMarge = (verkoopBedrag - kostPrijsBedrag).toFixed(2);
  const salesMargePercent = ((salesMarge / verkoopBedrag) * 100).toFixed(2);

  const handleSave = async () => {
    setIsSaving(true);
    console.log({ forecastId });
    try {
      const body = {
        formValues,
        rows,
        debtorId,
        forecastId,
      };
      const path = `/details`;

      const arg = { token, body };

      // Replace this with your API call function
      const response = await afasPoster(path, { arg });

      console.log('Saved successfully', response);
      window.parent.location.href = `${insiteUrl}/forecast-prs?FoId=${forecastId}`;

      // You can also trigger success notification or redirect here
    } catch (err) {
      console.error('Save failed:', err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div style={{ padding: '16px', marginTop: '24px' }}>
      <Typography variant="h5" style={{ color: '#3f51b5', marginBottom: '16px' }}>
        Totalen
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Verkoopbedrag"
            variant="filled"
            size="small"
            value={verkoopBedrag}
            InputProps={{ readOnly: true }}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Kostprijsbedrag"
            variant="filled"
            size="small"
            value={kostPrijsBedrag}
            InputProps={{ readOnly: true }}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Sales marge"
            variant="filled"
            size="small"
            value={salesMarge}
            InputProps={{ readOnly: true }}
            fullWidth
            margin="normal"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Sales marge %"
            variant="filled"
            size="small"
            value={salesMargePercent}
            InputProps={{ readOnly: true }}
            fullWidth
            margin="normal"
          />
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: '16px' }}>
        <Grid item>
          <Button variant="contained" color="secondary" size="large" disabled={isSaving}>
            Annuleren
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSave}
            disabled={isSaving}
            startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : null}
          >
            {isSaving ? 'Bezig met opslaan...' : 'Opslaan en sluiten'}
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};

export default OfferteTotals;
